import React, { useCallback, useState } from 'react'
import { Spin, Typography } from 'antd'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { AuthCard } from '../../components/Auth/AuthCard'
import { AuthForm } from '../../components/Auth/AuthForm'
import type { AuthFormData } from '../../types/auth'
import { useApi } from '../../services/ApiContext'
import { GoogleReCaptcha } from 'react-google-recaptcha-v3'
import { usePageTitle } from '../../utils/pageTitle'

const { Text } = Typography

export const LoginPage: React.FC = () => {
  usePageTitle('Sign In')
  const api = useApi()

  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)
  const [captcha, setCaptcha] = React.useState<string | null>(null)
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false)
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redirect')

  const onVerify = useCallback((token: string | null) => {
    setCaptcha(token)
  }, [])

  const navigate = useNavigate()

  const handleSubmit = async (data: AuthFormData) => {
    setLoading(true)
    if (!captcha) {
      setLoading(false)
      return
    }
    try {
      const success = await api.login({ ...data, captcha })
      if (success) {
        if (redirect) {
          navigate(redirect)
        } else {
          navigate('/app/documents')
        }
      }
    } catch {
      setError('failed')
    }
    setRefreshReCaptcha((r: boolean) => !r)
    setLoading(false)
  }

  return (
    <Spin spinning={loading} tip="Loading your studio...">
      <AuthCard>
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold mb-2">Sign in to SprintSpec</h1>
          <Text type="secondary">
            Enter your email and password to continue.
          </Text>
        </div>

        <AuthForm type="login" onSubmit={handleSubmit} />
        {error && (
          <Text type="danger" className="block mb-4 text-center">
            We couldn't log you in, please check your credentials and try again.
          </Text>
        )}

        {/* <AuthSocial /> */}

        <div className="text-center mt-8">
          <Text type="secondary">
            Don't have an account?{' '}
            <Link
              to="/signup"
              className="text-primary hover:text-primary-light"
            >
              Sign up
            </Link>
          </Text>
        </div>
        <GoogleReCaptcha
          refreshReCaptcha={refreshReCaptcha}
          onVerify={onVerify}
        />
      </AuthCard>
    </Spin>
  )
}
